module.exports = __webpack_public_path__ + "img/history_bg.ee252db4.png";